import React from "react";
import ContentEditable from 'react-contenteditable';
import PropTypes from 'prop-types';

class TextChange extends React.Component{
    constructor(props){
        super(props);
        this.contentEditable = React.createRef();
        // let MainText;
        // if (this.props.Text && JSON.parse(this.props.Text)[this.props.lang]) { // Если поле Text не пустое - смотрим есть ли текст конкретно для этого языка
        //     MainText = JSON.parse(this.props.Text)[this.props.lang];
        // } else {
        //     if (this.props.TextDefault) {// Если вообще нет текста или нет только для этого языка - текст должен быть как TextDefault
        //         MainText = '*'+this.props.TextDefault;
        //     } else { // Но если и TextDefault пустой - выводим:
        //         MainText = '*no data';
        //     }
        // }
        this.state = {
            Text : this.props.Text,
        };
        this.handleChange = this.handleChange.bind(this);
        this.BlurChange = this.BlurChange.bind(this);
    };

    handleChange = event => {this.setState({ Text: event.target.value});};
    BlurChange = () => {this.props.update(this.state.Text,this.props.ArrIndex,this.props.lang);};

    render() {
        if (this.props.Adminka){
        return (
            <ContentEditable
                innerRef={this.contentEditable}
                html={this.state.Text} // innerHTML of the editable div
                disabled={false}       // use true to disable editing
                onChange={this.handleChange} // handle innerHTML change
                onBlur = {this.BlurChange}
                tagName='div' // Use a custom HTML tag (uses a div by default)
            />
        )}
        else {
            // return <React.Fragment>{this.state.Text ? parse(this.state.Text) : this.props.TextDefault}</React.Fragment>
            return <React.Fragment>{this.state.Text}</React.Fragment>
        }
    }

}

export default TextChange

TextChange.propTypes = {
    Text: PropTypes.string,
    TextDefault: PropTypes.string,
    ArrIndex: PropTypes.string,
    handleChange: PropTypes.func,
    Adminka: PropTypes.bool
};